import customURLSearchParams from "./CustomURLSearchParams";

export const overrideService = {
  getOverride: async function () {
    let override = "";

    const params = customURLSearchParams();

    if (params.has("override")) override = params.get("override");

    return override;
  },
  getInlineDetails: async function () {
    let override = "";

    const params = customURLSearchParams();

    if (params.has("inlinedetails")) override = params.get("inlinedetails");

    return override === 'true';
  },
};

export default overrideService;
